import React from "react";
import styles from "./Bank.module.css";
import { useStateContext } from "../../lib/StateContext";
import { actions } from "../../lib/actions";
import { round } from "../../lib/utils";

function Bank({ className }) {
  const [state, dispatch] = useStateContext();

  const cashAvailable = React.useMemo(() => {
    return state.monies.cash;
  }, [state.monies]);

  const { chosenBank, options } = state.bank;

  React.useEffect(() => {
    if (state.tick % 5 === 0 && chosenBank && chosenBank.savingInt > 0) {
      dispatch(actions.bankAddInterest());
    }
  }, [state.tick, chosenBank, dispatch]);

  const onTransferMoney = React.useCallback(
    (to, from) => {
      let amount = 0;
      try {
        amount = parseInt(
          prompt(
            `How much money do you want to transfer? \n You have: ${state.monies[from]}`
          )
        );
      } catch {
        return;
      }
      if (!isNaN(amount)) {
        dispatch(
          actions.transferMoney(to, from, Math.min(amount, state.monies[from]))
        );
      }
    },
    [state.monies, dispatch]
  );

  return (
    <section className={`${className || ""} ${styles.container}`}>
      <h3>{chosenBank ? chosenBank.name : "Bank"} </h3>
      {!chosenBank ? (
        <table className="table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Savings Int</th>
              <th>Account Fees</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {options.map((bank) => (
              <tr key={bank.name}>
                <td>{bank.name}</td>
                <td>{bank.savingInt} %</td>
                <td>${bank.fees}</td>
                <td>
                  <button
                    className="btn btn-primary"
                    disabled={bank.fees > cashAvailable}
                    onClick={() => dispatch(actions.openBankAccount(bank))}
                  >
                    Open Account
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <table className="table">
          <tbody>
            <tr>
              <th>Bank</th>
              <td>${round(state.monies.bank)}</td>
              <td>Int: {chosenBank.savingInt} %</td>
              <td>
                <button
                  className="btn btn-primary"
                  onClick={() => onTransferMoney("cash", "bank")}
                >
                  Transfer to Cash
                </button>
              </td>
            </tr>
            <tr>
              <th>Cash</th>
              <td>${round(state.monies.cash)}</td>
              <td />
              <td>
                <button
                  className="btn btn-primary"
                  onClick={() => onTransferMoney("bank", "cash")}
                >
                  Transfer to Bank
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      )}
    </section>
  );
}

export default Bank;
